import { styled } from 'styled-components';
import { device, Theme, Utils } from 'team-hero-ui';

const { pxToRem, flexFn } = Utils;

export const FormStyled = styled.div`
  width: 100%;
  padding: ${pxToRem([24, 12])};
  border-radius: ${pxToRem(4)};
  border: solid ${pxToRem(1)} ${Theme.colors.greyShades.grey5};
  color: ${Theme.colors.primary.grey};
  margin-bottom: ${pxToRem(50)};

  @media ${device.sm} {
    padding: ${pxToRem([24, 36])};
  }
`;

export const FormSubTitleStyled = styled.div`
  margin-bottom: ${pxToRem(20)};
`;

export const FormTitleStyled = styled.div`
  margin-bottom: ${pxToRem(15)};
`;

export const FormDescriptionStyled = styled.div`
  margin-bottom: ${pxToRem(40)};
`;

export const ProgressWrapperStyled = styled.div`
  ${flexFn('space-between')}
  margin-bottom: ${pxToRem(30)};
  gap: 5%;

  div:first-child {
    width: 70%;
  }
`;

export const ButtonsWrapperStyled = styled.div`
  ${flexFn('space-between')}
  margin-top: ${pxToRem(10)};
`;
